let observer = new MutationObserver(mutations => {
    mutations.forEach(function (mutation) {
        handleAutofocus(mutation.addedNodes)
    })
})

let target = document.querySelector("body")
let config = { childList: true, subtree: true }
observer.observe(target, config)

function handleAutofocus(nodeList) {
    for (const node of nodeList) {
        if (node instanceof Element && node.hasAttribute("data-autofocus")) {
            node.focus()
            node.select?.()
            break
        } else {
            handleAutofocus(node.childNodes)
        }
    }
}
